import React from 'react';
import moment from 'moment';
import { HFBlock } from 'components';
import client from 'utils/Contentful';
import * as localeMap from './locale';

import {
  mapEntry,
} from './helper';

import './case-detail-page.css';

class CaseDetailPage extends React.PureComponent {
  constructor() {
    super();
    this.state = {}
  }
  componentDidMount() {
    const {
      locale,
      match : {
        params: { id }
      }
    } = this.props;
    client
      .getEntry(id)
      .then((item) => {
        item = mapEntry({item, locale});
        if(item.image) {
          client.getAsset(item.image.sys.id)
            .then(asset => {
              item.image = asset.fields.file.url;
              this.setState({...item});
            });
        } else {
          this.setState({...item, image: ""});
        }
      })
      .catch(console.error);
  }
  render() {
    const { props: { locale } } = this;
    const { state } = this;
    const { detail: lang } = localeMap[locale];
    return (
      <HFBlock
        className="case-detail-page"
        {...this.props}
      >
        <div className="kv">
          <div className="container">
            <div className="heading">{state.name}</div>
          </div>
        </div>
        <div className="container">
          <div className="content">
            <div>{lang.address}: {state.address}</div>
            <div>{lang.amount}: {state.amount && state.amount.toString().replace(/(\d)(?=(\d{3})+$)/g, '$1,')}</div>
            <div>{lang.client}: {state.client}</div>
            <div>{lang.during}:
              {state.dateStart &&
                (
                  moment(state.dateStart).format('YYYY-MM-DD') + "~" +
                  moment(state.dateEnd).format('YYYY-MM-DD')
                )
              }
            </div>
            <div>{lang.intro}: {state.intro}</div>
            <div>{lang.organizer}: {state.organizer}</div>
            <div>{lang.type}: {state.type}</div>
          </div>
          <div className="image-block">
            {state.image && <img src={state.image} key={Math.random()} alt="intro" />}
          </div>
        </div>
      </HFBlock>
    );
  }
}

export default CaseDetailPage;



// WEBPACK FOOTER //
// ./src/pages/CasePage/Detail.js